import { TableErrorBoundary } from '../../common/TableErrorBoundary';
import { TableErrorPlaceholder } from '../../common/TableErrorPlaceholder';
import type { TableLoadingStateProps } from './types';

export function TableLoadingState({
  loading,
  isTableReady,
  queryError,
  height,
  enableErrorBoundary,
  tableId,
  tableTitle,
  onRetry,
  children,
}: TableLoadingStateProps) {
  if (queryError) {
    return (
      <TableErrorPlaceholder
        error={queryError}
        onRetry={onRetry}
        tableTitle={tableTitle || tableId}
        height={height}
      />
    );
  }

  // Таблица рендерится всегда — чтобы Handsontable инициализировался в DOM.
  // Скрываем через visibility пока данные или HotTable ещё не готовы.
  const tableContent = (
    <div style={loading || !isTableReady ? { visibility: 'hidden' } : undefined}>
      {children}
    </div>
  );

  if (enableErrorBoundary) {
    return (
      <TableErrorBoundary tableId={tableId} tableTitle={tableTitle} height={height}>
        {tableContent}
      </TableErrorBoundary>
    );
  }

  return <>{tableContent}</>;
}
